module.exports = __webpack_public_path__ + "assets/tick-disabled.9105aa4d.svg";